import { useQuery, useMutation } from '@tanstack/react-query';
import { searchCandidates, fetchIndexStats, triggerSeed, resetFailed, pollIndex } from '../utils/ragApi';

export const useRagSearch = ({ query, top_k = 10, page = 1, pageSize = 10 }, options = {}) =>
  useQuery({
    queryKey: ['ragSearch', query, top_k, page, pageSize],
    queryFn: () => searchCandidates({ query, top_k, page, pageSize }),
    enabled: !!query && query.trim().length >= 3,  // don't fire on empty/short queries
    staleTime: 0,     // MUST be 0 — never serve cached search results (overrides global 2min default)
    retry: (failureCount, error) => {
      // Don't retry client errors (400 bad query, 422 validation, 429 rate limit)
      if ([400, 422, 429].includes(error?.response?.status)) return false;
      return failureCount < 2;
    },
    ...options,
  });

export const useIndexStats = (options = {}) =>
  useQuery({
    queryKey: ['ragIndexStats'],
    queryFn: fetchIndexStats,
    staleTime: 30_000,
    refetchInterval: 30_000,  // auto-refresh every 30s
    ...options,
  });

export const useTriggerSeed  = () => useMutation({ mutationFn: triggerSeed });
export const useResetFailed  = () => useMutation({ mutationFn: (ids) => resetFailed(ids) });
export const usePollIndex    = () => useMutation({ mutationFn: pollIndex });
